import React, { createContext, useContext, useEffect, useState, ReactNode } from 'react';

export type Lang = 'it' | 'en';

interface LanguageContextValue {
  lang: Lang;
  setLang: (l: Lang) => void;
}

const STORAGE_KEY = 'insolita.lang';

function initialLang(): Lang {
  try {
    const saved = localStorage.getItem(STORAGE_KEY);
    if (saved === 'it' || saved === 'en') return saved;
    // prima visita: se il browser è in inglese, parti in EN
    if (typeof navigator !== 'undefined' && navigator.language && navigator.language.toLowerCase().startsWith('en')) {
      return 'en';
    }
  } catch { /* ignore */ }
  return 'it';
}

const LanguageContext = createContext<LanguageContextValue>({ lang: 'it', setLang: () => {} });

export const LanguageProvider: React.FC<{ children: ReactNode }> = ({ children }) => {
  const [lang, setLangState] = useState<Lang>(initialLang);

  const setLang = (l: Lang) => {
    setLangState(l);
    try { localStorage.setItem(STORAGE_KEY, l); } catch { /* ignore */ }
    try { document.documentElement.lang = l; } catch { /* ignore */ }
  };

  useEffect(() => { try { document.documentElement.lang = lang; } catch { /* ignore */ } }, [lang]);

  return (
    <LanguageContext.Provider value={{ lang, setLang }}>
      {children}
    </LanguageContext.Provider>
  );
};

export const useLang = () => useContext(LanguageContext);
